import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, RouteProps } from "react-router-dom";
import queryString from "query-string";
import LoaderCentered from "../../Loader/LoaderCentered";

interface AuthState {
  auth: {
    loaded: boolean;
    isAnonymous: boolean;
  };
}

export interface AuthenticatedRouteProps extends Omit<RouteProps, "render"> {
  children: React.ReactNode;
}

export function AuthenticatedRoute({
  children,
  ...rest
}: AuthenticatedRouteProps): JSX.Element {
  const [isLoading, isAnonymous] = useSelector(({ auth }: AuthState) => [
    auth.loaded === false,
    auth.isAnonymous,
  ]);

  if (isLoading) {
    return <LoaderCentered />;
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (isAnonymous) {
          // Preserve all existing query params and add redirect
          const existingQuery = queryString.parse(props.location.search);
          const redirectUrl = queryString.stringifyUrl({
            url: "/login",
            query: {
              ...existingQuery,
              redirect: props.location.pathname + props.location.search,
            },
          });
          return <Redirect to={redirectUrl} />;
        }
        return <>{children}</>;
      }}
    />
  );
}
